import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CustomerOverViewService} from '~features/customer-overview/customer-overview.service';
import {NotificationType} from '~core/enum';
import {ButtonsTranslations} from '~shared/components/buttons/buttons-translations.service';
import {SpinnerService} from '~shared/components/buttons/spinner/spinner.service';
import {FormLabelTranslationService} from '~shared/components/form-fields/translations/form-label-translations.service';
import {CrmMembership, Customer} from '~core/models';
import {DefaultNotificationService, MembershipService} from '~core/services';
import {CustomerOverviewTranslationsService} from '~shared/translations';


/**
 * Handles the API calls for membership
 */
@UntilDestroy()
@Component({
  selector: 'app-crm-membership',
  templateUrl: './crm-membership.component.html',
  styleUrls: ['../../../../customer-overview.component.scss']
})
export class CrmMembershipComponent implements OnInit, OnDestroy {
  public currentMembership: CrmMembership;
  public createMembershipForm: UntypedFormGroup;
  public apiCustomerPrefix: string = '/api/customers/';
  public spinnerName: string = 'updateMembership';

  @Input() public customer: Customer;

  constructor(
    private spinnerService: SpinnerService,
    private membershipService: MembershipService,
    private formBuilder: UntypedFormBuilder,
    private notificationService: DefaultNotificationService,
    public buttonsTranslations: ButtonsTranslations,
    public customerOverviewService: CustomerOverViewService,
    public customerOverviewTranslations: CustomerOverviewTranslationsService,
    public flTranslations: FormLabelTranslationService
  ) {
  }

  public ngOnInit(): void {
    this.fillMembershipForm();
  }

  public ngOnDestroy(): void {
  }

  /**
   * Fill the bank data form.
   */
  public fillMembershipForm(): void {
    this.createMembershipForm = this.formBuilder.group({
      customer: `${this.apiCustomerPrefix}${this.customer.id}`,
      membershipNumber: [null, [Validators.required]],
      comment: [''],
      joinDate: [null, [Validators.required]],
      status: ['member']
    });
  }

  /**
   * If bank form is valid update the bank data, otherwise display errors.
   */
  public createMembershipFormSubmit(form: UntypedFormGroup): void {
    if (form.valid) {
      this.spinnerService.show(this.spinnerName);
      this.membershipService.create(form.value).pipe(untilDestroyed(this))
        .subscribe({
          next: (data: any) => {
            this.spinnerService.hide(this.spinnerName);
            this.membershipService.announceCurrentMembership(data);
            this.notificationService.showNotification({
              type: NotificationType.SUCCESS,
              message: this.customerOverviewTranslations.i18nSuccessMembershipCreate
            });
            this.customerOverviewService.toggleAllModal(false);
          },
          error: (error: Error) => {
            this.spinnerService.hide(this.spinnerName);
            this.notificationService.showNotification({
              type: NotificationType.ALERT,
              message: this.customerOverviewTranslations.i18nErrorMembershipCreate
            });
          }
        });
    }
  }

}
